import { FC } from 'react';
import cn from 'classnames';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage } from 'react-intl';
import NextImage from 'src/shared-components/NextImage/NextImage';
import trns from './trns';
import Comment from './Comment';

export const CommentsContainerId = 'comments-container';
const commentsList = [
  {
    id: 1,
    icon: 'comments/user11.svg',
    name: 'Катерина Приходько',
    date: '22.04.2022',
    comment: <FormattedMessage {...trns.comment1} />
  },
  {
    id: 2,
    icon: 'comments/user2.svg',
    name: 'Олена Мартинчук',
    date: '5.05.2022',
    comment: <FormattedMessage {...trns.comment2} />
  },
  {
    id: 3,
    icon: 'comments/user3.svg',
    name: 'Леонід Остапенко',
    date: '18.05.2022',
    comment: <FormattedMessage {...trns.comment3} />
  }
];

const PartnersContainer: FC = () => {
  return (
    <div className={cn('hidden m:flex m:py-10')} id={CommentsContainerId}>
      <Constraints className="w-full">
        <div className="flex flex-col w-full items-center justify-center">
          <h2 className="uppercase text-astronautBlue fs-header4-bold text-center">
            <FormattedMessage {...trns.commentsTitle} />
          </h2>
          <div className="flex flex-row mt-14 w-full gap-4">
            {commentsList.map((comment) => {
              return (
                <div
                  className="shadow-md rounded-xl p-5 h-full flex-1"
                  key={comment.id}
                >
                  <div className="flex">
                    <div>
                      <NextImage
                        alt="line"
                        src={comment.icon}
                        layout="fixed"
                        height={48}
                        width={48}
                      />
                    </div>
                    <div className="pl-2.5 pb-2.5">
                      <div className="uppercase text-astronautBlue fs-body-reg">
                        {comment.name}
                      </div>
                      <div className="text-silver fs-caption-reg">
                        {comment.date}
                      </div>
                    </div>
                  </div>
                  <Comment text={comment.comment} />
                </div>
              );
            })}
          </div>
        </div>
      </Constraints>
    </div>
  );
};

export default PartnersContainer;
